import { FC } from 'react'

import FormikField from '../../form/FormikField'
import { FormikFormProps } from '../../form/FormikForm'
import { ActionButtonVariant } from '../../components/ActionButton/styled'
import { FormSubmitButtonProps } from '../../form/FormSubmitButton'
import FormMessages, { FormMessagesProps } from '../../form/FormMessages'
import { FormFieldInputProps } from '../../form/fields/FormFieldInput'
import { FormFieldDropdownSelectProps } from '../../form/fields/FormFieldDropdownSelect'
import { FormFieldAutoSuggestProps } from '../../form/fields/FormFieldAutoSuggest'

import * as SC from './styled'

type AdsAlertFormValues = {
  categories: Array<string>
  localization: string
  specialities: Array<string>
  term: string
}

export type AdsAlertFormProps = FormikFormProps<AdsAlertFormValues> & {
  fields: {
    categories: Omit<FormFieldDropdownSelectProps, 'name'>
    localization: Omit<FormFieldAutoSuggestProps, 'name'>
    specialities: Omit<FormFieldDropdownSelectProps, 'name'>
    term: Omit<FormFieldInputProps, 'name'>
  }
  submitButton?: FormSubmitButtonProps
  errors?: FormMessagesProps['messages']
}

const AdsAlertForm: FC<AdsAlertFormProps> = ({
  fields,
  submitButton,
  errors,
  ...formikProps
}) => {
  const { categories, localization, specialities, term } = fields

  return (
    <SC.Container>
      <SC.Form {...formikProps}>
        <SC.Fields>
          <FormikField
            {...categories}
            labelProps={{ underlined: true }}
            name="categories"
            Component={SC.CategorySelect}
          />
          <FormikField
            {...localization}
            labelProps={{ underlined: true }}
            name="localization"
            type="text"
            Component={SC.AutoSuggestField}
          />
          <FormikField
            {...specialities}
            name="specialities"
            labelProps={{ underlined: true }}
            Component={SC.SpecialitySelect}
          />
          <FormikField
            {...term}
            name="term"
            labelProps={{ underlined: true }}
            Component={SC.TermInput}
          />
        </SC.Fields>
        {errors && <FormMessages messages={errors} />}
        <SC.Actions>
          <SC.SubmitButton
            type={'submit'}
            variant={ActionButtonVariant.quaternary}
            {...submitButton}
          />
        </SC.Actions>
      </SC.Form>
    </SC.Container>
  )
}

export default AdsAlertForm
